import { render, staticRenderFns } from "./NewEditProfessorPage.vue?vue&type=template&id=2bf35c72"
import script from "./NewEditProfessorPage.vue?vue&type=script&lang=js"
export * from "./NewEditProfessorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports